<template>
    <div>        
        <v-row justify="center">
            <v-dialog persistent v-model="dialog" max-width="500">
                <v-card class="mx-auto">
                    <v-toolbar color="blue" dark>
                        <v-toolbar-title>{{titulo}}</v-toolbar-title>
                        <v-spacer></v-spacer>
                    </v-toolbar>
                    <v-card-text class="pb-0">
                        <v-row align="center" class="mx-0 mt-4">
                        </v-row>
                        <div class="my-4 subtitle-1 black--text">
                            <strong>Seleccione un rango de fechas</strong>

                            <v-row>
                                <v-col sm="6" md="4">
                                    <date-picker v-model="dateFrom" format="DD-MM-YYYY HH:mm" type="datetime" :lang="lang" placeholder="Desde"></date-picker>
                                </v-col>
                                <v-col sm="6" md="4" class="ml-14">
                                    <date-picker v-model="dateTo" format="DD-MM-YYYY HH:mm" type="datetime" :lang="lang" placeholder="Hasta"></date-picker>
                                </v-col>
                            </v-row>
                        </div>
                    </v-card-text>
                    <v-card-actions class="px-6 pb-6">
                        <v-spacer></v-spacer>
                        <v-btn text small @click="dialog = false">
                            Cancelar
                        </v-btn>
                        <v-btn color="blue" dark small @click="onAccept">
                            {{botonAceptar}}
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-row>

        <v-container fluid class="pt-0" v-if="showFilter">
            <v-row>
                <v-col cols="12" sm="12" md="12">
                    <v-card max-width="80%" class="mx-auto">
                        <v-toolbar color="blue" dark>
                            <slot name="header"></slot>
                        </v-toolbar>
                        <v-container class="grey lighten-5" v-for="(variable,index) in multipleVariables" v-bind:key="index">
                            <v-row>
                                <v-col cols="12" sm="4" class="pb-0">
                                    <v-autocomplete class="pr-3 mx-240" 
                                                    v-model="multipleVariables[index].selInstalation" 
                                                    :items="listInstalations" 
                                                    label="Seleccione la instalación"
                                                    item-text="fldTNombre" 
                                                    item-value="idNInstalacion" 
                                                    v-on:change="bindElementsbyInstalation(multipleVariables[index].selInstalation, index)"
                                                    clearable outlined dense></v-autocomplete>
                                </v-col>
                                <v-col cols="12" sm="4" class="pb-0">
                                    <v-autocomplete :disabled="arrayListElements[index].length === 0"
                                              :items="arrayListElements[index]"
                                              label="Seleccione un elemento"
                                              item-text="fldTNombre"
                                              item-value="idNElemento"
                                              v-model="multipleVariables[index].selElement"
                                              v-on:change="bindVariablesbyElement(multipleVariables[index].selElement, index)"
                                              clearable
                                              dense
                                              outlined>
                                    </v-autocomplete>
                                </v-col>
                                <v-col cols="8" sm="3" class="pb-0">
                                    <v-autocomplete :items="arrayListVariable[index]"
                                              :disabled="arrayListVariable[index].length == 0"
                                              label="Seleccione una variable"
                                              item-text="fldTNombre"
                                              item-value="idNVariable"
                                              v-model="multipleVariables[index].selVariable"
                                              clearable
                                              dense
                                              outlined>
                                    </v-autocomplete>
                                </v-col>
                                <v-col cols="8" sm="1" class="pb-0">
                                    <v-btn color="blue" dark small @click="addVariable" v-if="index===0">
                                        +
                                    </v-btn>
                                    <v-btn color="red" dark small @click="removeVariable(index)" v-if="index>0">
                                        -
                                    </v-btn>
                                </v-col>
                            </v-row>


                        </v-container>
                        <v-row class="mr-1">
                            <v-col cols="12" class="d-flex flex-row-reverse pt-0">
                                <v-btn color="blue" dark small @click="dialog = true" :disabled="!selVariableComputed">
                                    Seleccionar fecha
                                </v-btn>
                            </v-col>
                        </v-row>

                    </v-card>
                </v-col>
            </v-row>
        </v-container>
    </div>
</template>

<script>
    var today = new Date();
    var yesterday = new Date();
    yesterday.setDate(today.getDate() - 1);

    import {
        Component,
        Prop,
        Vue,
        Watch,
        computed
    } from "vue-property-decorator";
    import InstalationService from '@/services/InstalationsService';
    import InstalationModel from '@/models/InstalationModel';
    import ElementService from '@/services/ElementService';
    import VariableService from '@/services/VariableService';
    import ElementTypeService from "../services/ElementTypeService";
    import VariableClassService from "../services/VariableClassService";
    import DatePicker from 'vue2-datepicker';
    import 'vue2-datepicker/index.css';

    @Component({
        components: {
            DatePicker
        },
        data() {
            return {
                lang: {
                    formatLocale: {
                        firstDayOfWeek: 1,
                    },
                },
            };
        },
        props: {
            titulo: {
                default: 'Gráfica de Temperaturas',
                type: String
            },
            esGraficas: {
                default: 1,
            },
            botonAceptar: {
                default: 'Aceptar'
            }
        }
    })
    export default class FiltroDatosMultiVariable extends Vue {
        mounted() {
            this.loadData();
        }
        date = "";
        timezone = '';
        showFilter = true;
        dialog = false;
        listInstalations = [];
        selInstalation = null;
        listElements = [];
        listElementTypes = [];
        selElement = null;
        listVariable = [];
        listVariableTypes = [];
        selVariable = null;
        dateFrom = yesterday;
        dateTo = today;        
        dateFromMenu = false;
        dateToMenu = false;        
        listIcons = [];
        multipleVariables = [
            {
                selInstalation: null, selElement: null, selVariable: null
            }
        ]
        arrayListElements = [[]];
        arrayListVariable = [[]];

        async loadData() {
            await this.loadIcons();

            var resultTypeEle = await new ElementTypeService().list({});
            if (resultTypeEle.success) {
                this.listElementTypes = resultTypeEle.data;
            }
            else {
                this.showError('Ocurrio un error: ' + resultTypeEle.Message);
            }

            var resultVC = await new VariableClassService().list({});
            if (resultVC.success) {
                var resVC = resultVC.data;
                if (resVC != null) {
                    this.listVariableTypes = resVC;
                }
            }
            else {
                this.showError('Ocurrio un error: ' + resultVC.Message);
            }  

            var resultInst = await new InstalationService().list({});
            if (resultInst.success) {
                let resInst = resultInst.data;
                if (resInst != null) {
                    this.listInstalations = resInst.sort((a, b) => a.fldTNombre.localeCompare(b.fldTNombre, 'en', { sensitivity: 'base' }));
                }
            }
            else {
                this.showError('Ocurrio un error: ' + resultInst.Message);
            }

            this.arrayListElements.push([]);
            this.arrayListVariable.push([]);
        }

        async loadIcons() {
            var iList = this.$store.getters.getIconList;
            var self = this;
            if (!iList) {
                this.$store.dispatch("loadIconList").then(() => {
                    self.listIcons = self.$store.getters.getIconList;
                });
            } else {
                this.listIcons = iList;
            }
        }

        addVariable() {
            if (this.multipleVariables.length < 10) {
                this.multipleVariables.push({ selInstalation: null, selElement: null, selVariable: null });
                this.arrayListElements.push([]);
                this.arrayListVariable.push([]);
            }
            else {
                alert('Solo puede seleccionar hasta 10 variables');
            }
        }

        removeVariable(index) {            
            this.multipleVariables.splice(index, 1);
        }

        onAccept() {
            this.dialog = false;

            let valueList = [];
            var self = this;
            this.multipleVariables.forEach(function (valor, indice, array) {
                let value = {
                    idNInstalacion: valor.selInstalation,
                    idNElements: valor.selElement,
                    idNVariable: valor.selVariable,
                    nombreInstalacion: self.listInstalations.find(x => x.idNInstalacion == valor.selInstalation).fldTNombre,
                    nombreElemento: self.arrayListElements[indice].find(x => x.idNElemento == valor.selElement).fldTNombre,
                    nombreVariable: self.arrayListVariable[indice].find(x => x.idNVariable == valor.selVariable).fldTNombre,
                    from: self.dateFrom,
                    to: self.dateTo
                }
                valueList.push(value);

            });
           
            this.$emit('selectedValues', valueList);
        }       

        @Watch('selInstalation')
        async watchSelInstalation(newValue) {
            this.listElements = [];
            this.selElement = null;
            this.listVariable = [];
            this.selVariable = null;
            var self = this;
            if (newValue > 0) {
                let res = await new ElementService().listByInstalation(newValue, this.esGraficas);
                if (res.success) {
                    res.data.forEach(v => {
                        let et = self.listElementTypes.find(ve => ve.idNTipoElemento == v.fkNTipoElemento);
                        v.fldTRuta = '';
                    });
                    this.listElements = res.data.sort((a, b) => a.fldTNombre.localeCompare(b.fldTNombre, 'en', { sensitivity: 'base' }));
                }
            }
        }

        @Watch('selElement')
        async watchselElement(newValue) {
            this.listVariable = [];
            this.selVariable = null;
            var self = this;
            if (newValue > 0) {
                var res;
                var resV = await new VariableService().listcombo({ fkNElemento: newValue, fkGraficable: this.esGraficas });
                if (resV.success) {
                    res = resV.data;
                }
                else {
                    this.showError('Ocurrio un error: ' + resV.Message);
                    return;
                }  

                if (res) {
                    res.forEach(v => {
                        let et = self.listVariableTypes.find(ve => ve.idNTipoVariable == v.fkNTipoVariable);
                        v.fldTRuta = '';
                    });

                    this.listVariable = res.sort((a, b) => a.fldTNombre.localeCompare(b.fldTNombre, 'en', { sensitivity: 'base' }));
                }
            }
        }

       
        async bindElementsbyInstalation(selInstalation, index) {            
            this.listElements = [];
            this.selElement = null;
            this.listVariable = [];
            this.selVariable = null;            
            //console.log(selInstalation)  
            if (selInstalation > 0) {
                let res = await new ElementService().listByInstalation(selInstalation, this.esGraficas);
                if (res.success) {
                    res.data.forEach(v => {
                        let et = this.listElementTypes.find(ve => ve.idNTipoElemento == v.fkNTipoElemento);
                        v.fldTRuta = '';
                    });                    
                    this.listElements = res.data.sort((a, b) => a.fldTNombre.localeCompare(b.fldTNombre, 'en', { sensitivity: 'base' }));                    
                }
            }                       
            this.arrayListElements.splice(index, 1, this.listElements);
            this.arrayListVariable.splice(index, 1, this.listVariable);   
        }

        async bindVariablesbyElement(selElement, index) {            
            this.listVariable = [];
            this.selVariable = null;            
            if (selElement > 0) {
                var res;
                var resV = await new VariableService().listcombo({ fkNElemento: selElement, fkGraficable: this.esGraficas });
                if (resV.success) {
                    res = resV.data;
                }
                else {
                    this.showError('Ocurrio un error: ' + resV.Message);
                    return;
                }

                if (res) {
                    res.forEach(v => {
                        let et = this.listVariableTypes.find(ve => ve.idNTipoVariable == v.fkNTipoVariable);
                        v.fldTRuta = '';
                    });

                    this.listVariable = res.sort((a, b) => a.fldTNombre.localeCompare(b.fldTNombre, 'en', { sensitivity: 'base' }));
                }
            }
            this.arrayListVariable.splice(index, 1, this.listVariable);            
        }

        get selVariableComputed() {            
            let countSelElement = this.multipleVariables.filter(p => p.selVariable != null).length
            return this.multipleVariables.length==countSelElement
        }

       
        
    }
</script>